import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import {
  AppNotifications,
  VideoStatus,
  VideoFlag,
  FORM_MODE,
  VIDEO_MODE,
  RootState,
  TCb,
  LanguageOutputModel,
  VideoInputModel,
  VideoOutputModel,
  VideoCategoryOutputModel
} from "../../../../../models";
import { VideoService, BlogService } from "../../../../../services";
import { NotificationActions, AllLanguageListActions } from "../../../../../store/actions";
import VideoFormPresenter from "./VideoForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./VideoForm.type";
import { loadCallback } from "../../../../../utils";
import { withRouter } from "react-router-dom";
import { CATEGORY_TYPES } from "../../../../../constants";

class VideoFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      mode: FORM_MODE.CREATE,
      loading: false,
      initData: null,

      videoStatus: {
        status: false,
      },

      languageData: this.props.all_language_list.data,
      activeLanguageId: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
      filter: {
        code: ""
      },
      categories: [],
      videoDetail: null,

      fileUpload: "",
    };
  }

  onLoadVideoCategories = (languageId?: string) => {
    BlogService.filterCategories({
      limit: 150,
      type: CATEGORY_TYPES.VIDEO,
      languageId: languageId,
    })
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          let cates: VideoCategoryOutputModel[] = res.data.data;
          this.setState({ categories: cates });
        }
      })
      .catch((err) => {
        this.setState({
          categories: [],
        });
      });
  };

  onChangeLanguage = (languageId: string) => {
    this.setState({
      activeLanguageId: languageId
    });
    this.onLoadVideoCategories(languageId);
  };

  onChangeBannerStatus = (status: boolean) => {
    this.setState((prevState) => {
      return {
        videoStatus: {
          ...prevState.videoStatus,
          status,
        },
      };
    });
  };

  handleFileUpload = (event) => {
    const file: File = event.target.files[0];

    if (file) {
      this.setState({
        fileUpload: file,
      }, () => {
        this.onUploadVideo();
      })
    }
  }

  onSubmit = (val: any) => {
    let data: VideoInputModel[] = [];

    this.state.languageData.forEach((lang) => {
      const categoryId = val[`categoryVideoId${lang.id}`];
      const cateIds = categoryId ? (Array.isArray(categoryId) ? categoryId : [categoryId]) : [];

      if (val[`title${lang.id}`]) {
        let dataObj: any = {
          title: val[`title${lang.id}`],
          description: val[`description${lang.id}`],
          video: this.state.fileUpload,
          linkVideo: val.linkVideo,
          status: this.state.videoStatus.status ? VideoStatus.PUBLISH : VideoStatus.UNPUBLISH,
          categoryIds: cateIds,
          languageId: lang.id,
          flag: this.props.type === 0 ? VideoFlag.HOMEPAGE : VideoFlag.RESOURCE
        }
        const found = this.state.initData?.find((i) => i.languageId === lang.id) || false;
        this.state.mode !== FORM_MODE.CREATE &&
          found &&
          Object.assign(dataObj, {
            id: this.state.initData?.find((i) => i.languageId === lang.id)?.id,
          });
        // dataObj = _.pickBy(dataObj, (v) => !_.isUndefined(v));
        data.push(dataObj);
      }
    })

    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateVideo(data);
    }
    else {
      this.onUpdateVideo(data);
    }
  };

  onUploadVideo = () => {
    const formData = new FormData();
    formData.append("video", this.state.fileUpload);
    VideoService.uploadVideo(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.setState({
            fileUpload: res.data.data
          })
          this.props.actions.enqueueSnackbar({ type: AppNotifications.SUCCESS, message: "Upload video success" });
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload video failed" });
        }
      })
      .catch((err) => {
        console.log(err)
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload video failed" });
      });
  };

  onLoadAllLanguageVideoDetail = (videoCode: string, cb?: TCb) => {
    this.setState({ loading: true, initData: null }, () => {
      VideoService.getVideo(videoCode)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            const data: VideoOutputModel[] = res.data.data;
            const video = data[0].video;

            data.forEach((item) => {
              this.setState({
                videoStatus: {
                  status: item.status === VideoStatus.PUBLISH
                },
              })
            })

            this.setState(
              {
                mode: FORM_MODE.EDIT,
                videoDetail: data,
                initData: data,
                loading: false,
                fileUpload: video
              },
              () => {
                loadCallback(cb?.success);
              }
            );
          }
          else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Load data failed",
            });
            this.props.history.goBack();
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Load data failed",
          });
        });
    });
  };

  onCreateVideo = (data) => {
    VideoService.createVideo(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create video success",
          });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create video failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create video failed" });
      });
  };

  onUpdateVideo = (data) => {
    VideoService.updateVideo(this.props.videoCode!, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Update video success",
          });
          loadCallback(this.props.onComplete_Update);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update video failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update video failed" });
      });
  };

  onDeleteVideo = (videoCode) => {
    VideoService.deleteVideo(videoCode)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete video success",
          });
          loadCallback(this.props.onComplete_Delete);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete video failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete video failed" });
      });
  };

  componentDidMount = () => {
    if (this.props.videoCode) {
      this.onLoadAllLanguageVideoDetail(this.props.videoCode);
    }

    if (this.props.type === VIDEO_MODE.HOMEPAGE && this.state.mode === FORM_MODE.CREATE) {
      this.setState({
        videoStatus: {
          status: true 
        }
      })
    }

    if (this.state.categories) {
      this.onLoadVideoCategories(this.state.activeLanguageId);
    }
  };

  render() {
    return (
      <VideoFormPresenter
        {...this.props}
        {...this.state}
        onChangeLanguage={this.onChangeLanguage}
        onChangeBannerStatus={this.onChangeBannerStatus}
        onDeleteVideo={this.onDeleteVideo}
        handleFileUpload={this.handleFileUpload}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    })
  )(VideoFormContainer)
);
